import { Component } from '@angular/core';
import { AppComponent } from '../../../app.component';
import { AppSettings } from '../../../app.settings';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent {

  userFormIndication:string="login";
  BASE_LOGIN:any="";
  constructor(){
    this.BASE_LOGIN = `${AppSettings.BASE_LOGIN}`;
  }

  navigateForm(event:any){
    this.userFormIndication=event;
  }

}
